import { createReducer } from 'src/services/store/utils'
import { OrderState } from '../../controllers/types'
import { INITIAL_STATE } from '../../store/state'
import ACTIONS from '../actions'

export const order = createReducer<OrderState>(INITIAL_STATE.order, {
  [ACTIONS.RECEIVE_ORDER_UPDATE]: (state, action) => {
    return {
      ...state,
      ...action.order,
    }
  },
})
